import {useEffect, useState} from "react"
import {doGet, doPost}       from "../../util/do-fetch"
import Joyride               from "react-joyride"
import {useTheme}            from "@mui/material"


const Tour = ({token, last, onReady, onComplete}) => {

	const theme = useTheme()
	const [steps, setSteps] = useState(null)

	useEffect(()=>{
		const fetchSteps = async () => {
			try {
				const response = await doGet(`/mini/tour/${token}`)
				if(response.ok) {
					const tour = await response.json()
					const tourSteps = tour && tour.steps
					setSteps(tourSteps)
					onReady && onReady(!!(tourSteps && tourSteps.length))
				}
				else {
					setSteps(null)
					onReady && onReady(false)
				}
			}
			catch (err) {
				setSteps(null)
				onReady && onReady(false)
			}
		}
		fetchSteps()
	}, [token])

	const markTourComplete = async () => {
		try {
			await doPost(`/mini/tour/${token}`)
		}
		catch (err) {
			setSteps(null)
		}
	}

	const handleJoyrideCallback = async (data) => {
		const { type } = data

		if(type==="tour:end") {
			await markTourComplete()
			onComplete && onComplete()
		}
	}

	return steps &&
		<Joyride
			steps={steps}
			run={true}
			disableScrollParentFix={true}
			disableOverlayClose={true} // Prevent skipping steps by clicking outside
			spotlightClicks={true} // Allow clicks on highlighted elements
			continuous={true}
			callback={handleJoyrideCallback}
			showSkipButton={true}
			styles={{
				spotlight: { marginTop: '75px' },
				options: {
					zIndex: 10000, // Ensure the tour is above other components
				},
				buttonNext: {
					backgroundColor: theme.palette.secondary.main, // Use theme's success color for "Next" button
					color: theme.palette.secondary.contrastText, // Ensure text is readable
				},
				buttonBack: {
					color: theme.palette.secondary.main, // Use theme's success color for "Back" button
				},
				buttonSkip: {
					backgroundColor: theme.palette.secondary.main, // Use theme's success color for "Skip" button
					color: theme.palette.secondary.contrastText, // Ensure text is readable
				},
			}}
			locale={{
				last: last || "Done"
			}}
		/>
}

export default Tour